import isMongoId from '../../helpers/is-mongo-id';
import { z } from 'zod';
import { InvestorAccessPermission } from 'further-types/further-user';

export const ListAccessGrantsInput = z.object({
  investorId: z.string().refine(isMongoId()),
  firmId: z.string().refine(isMongoId()),
});

export const RemoveAccessGrantInput = z.object({
  investorId: z.string().refine(isMongoId()),
  furtherUserId: z.string().refine(isMongoId()),
  firmId: z.string().refine(isMongoId()),
});

export const UpdateAccessGrantInput = z.object({
  investorId: z.string().refine(isMongoId()),
  furtherUserId: z.string().refine(isMongoId()),
  accessPermissions: z.array(z.nativeEnum(InvestorAccessPermission)),
  copyIntoSystemEmails: z.boolean(),
  firmId: z.string().refine(isMongoId()),
});

export const CreateAccessGrantInput = z.object({
  investorId: z.string().refine(isMongoId()),
  firmId: z.string().refine(isMongoId()),
  email: z.string().email(),
  copyIntoSystemEmails: z.boolean(),
  accessPermissions: z.array(z.nativeEnum(InvestorAccessPermission)),
});
